export const getDropzone = (fieldId?: string): HTMLElement | undefined => {
	if (!fieldId) return undefined;
	const id = `${fieldId}-dropzone-container`;
	return document.getElementById(id) ?? undefined;
};
